/*
 * @Author: cyw
 * @Date: 2020-04-28 15:50:32
 * @LastEditors: cyw
 * @LastEditTime: 2020-05-26 18:10:47
 * @Descripttion:
 */
import axios from 'axios';
import { Toast } from 'vant';
import router from '@/router'
//import { getToken } from '@/utils/auth';

// 创建 axios 实例
const service = axios.create({
	timeout: 600000, // 请求超时时间
	baseURL: process.env.NODE_ENV === "development" ? "/Api" : GLOBAL.BASE_URL,
	headers: {
		"Content-Type": "application/json;charset=UTF-8"
	}
});
service.defaults.withCredentials = true;
// request 拦截器
service.interceptors.request.use(
	config => {
		var toast = config.toast || "加载中...";
		Toast.loading({
			duration: 0,
			forbidClick: true,
			loadingType: 'spinner',
			message: toast
		});
		// config["baseURL"] = 'http://sf-system.leanin.com.cn';
		// config["baseURL"] = 'http://192.168.0.21:8580';
		config.url = "/api" + config.url;//生产环境需要带api
		// config.url =  config.url;
		return config;
	},
	error => {
		Promise.reject(error);
	}
);

// response 拦截器
service.interceptors.response.use(
	response => {
		const { data } = response;
		Toast.clear();
		if (data.code === 200) {
			return data;
		} else {
			Toast({
				duration: 2000,
				message: data.code + ':' + data.message
			})
			return Promise.resolve(data)
		}
	},
	error => {
		Toast.clear();
		Toast({
			duration: 2000,
			message: '网络错误'
		});
		Promise.reject(error);
	}
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js